require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-1-wt-o-24.json") })
        }
      }, "path---photos-professional-1-wt-o-24");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-1-wt-o-24!./.cache/json/photos-professional-1-wt-o-24.json
// module id = 636
// module chunks = 231608221292675